/**
* @ngdoc component
* @name common.component:itxDownloadApp
* @description
* Download APP banner showed in the home page for
* mobile devices.
*/
(function() {
  'use strict';
  
   var itxDownloadApp = {
    bindings: {
      onCloseBanner: '&'
    },
    controller:   itxDownloadAppCtrl,
    templateUrl: 'download-app.component.html'
  };

  itxDownloadAppCtrl.$inject = [
    'ItxStaticResourceSvc',
    'imEventServiceWrapper',
    'mdUtils'
  ];

  function itxDownloadAppCtrl (
    ItxStaticResourceSvc,
    imEventServiceWrapper,
    mdUtils
  ) {
    var _this = this;

    _this.$onInit = function () {
      _this.banner = 'downloadApp';
      _this.type = 1;
      _this.logo = ItxStaticResourceSvc.getImage('logo_massimo_dutti.ico');
      _this.smart_app_img = ItxStaticResourceSvc.getImage('banners/smart_app/smart_app.png');
      _this.linkToApp = mdUtils.getLinkDownloadApp();

      if(window.Optimize && window.Optimize.showBanner){
        _this.type = window.Optimize.showBanner;
      }
    };    

    _this.goToApp = function(){
      _this.onCloseBanner({banner: _this.banner, hideBannerNextTime:true });
      imEventServiceWrapper.sendBasicAnalytics('corporativo','app', 'descarga_app');
    };

    _this.onCancel = function () {
      _this.onCloseBanner({banner: _this.banner, hideBannerNextTime:true });
    };
  } 

  angular.module('itxApp.common')
  .component('itxDownloadApp',itxDownloadApp);

})();